import type { TimeSlot } from '@klareospace/pharos-lib-types';

import { setHoursMinutes, toTimeOfDay } from '../time-of-day-select';
import type { DateTimeRangeValue } from './date-time-range-picker';

/** Converts a stored `TimeSlot` into a `DateTimeRangePicker` value, defaulting to "now" when undefined. */
export function toDateTimeRangeValue(timeSlot: TimeSlot | undefined): DateTimeRangeValue {
  const now = new Date();
  const start = timeSlot ? new Date(timeSlot.start) : now;
  const end = timeSlot ? new Date(timeSlot.end) : now;
  return { date: start, end: toTimeOfDay(end), start: toTimeOfDay(start) };
}

/** Converts a `DateTimeRangePicker` value back into a `TimeSlot`. */
export function toTimeSlot(value: DateTimeRangeValue): TimeSlot {
  return { end: setHoursMinutes(value.date, value.end), start: setHoursMinutes(value.date, value.start) };
}
